const DOMPropNames = new Set(['id']);
const labelablePropNames = new Set([
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'aria-details',
]);
const propRe = /^(data-.*)$/;
export function filterDOMProps(props, options = {}) {
    const { labelable, propNames } = options;
    const filteredProps = {};
    for (const prop in props) {
        if (Object.prototype.hasOwnProperty.call(props, prop) &&
            (DOMPropNames.has(prop) ||
                (labelable && labelablePropNames.has(prop)) ||
                (propNames === null || propNames === void 0 ? void 0 : propNames.has(prop)) ||
                propRe.test(prop))) {
            // @ts-expect-error
            filteredProps[prop] = props[prop];
        }
    }
    return filteredProps;
}
